module.exports = __webpack_public_path__ + "static/media/icon-chevron-up.a6b2d0bb.svg";